import React, { UIEventHandler, useCallback } from 'react';

import { Pagination } from 'enums';
import { useTypedDispatch } from 'hooks/useTypedDispatch';

type ScrollPaginationType = {
  count: number | undefined;
  dataArrayLength: number;
  page: number;
  actionCreator: Function;
};

export const useScrollPagination = ({
  count,
  page,
  dataArrayLength,
  actionCreator,
}: ScrollPaginationType): UIEventHandler => {
  const dispatch = useTypedDispatch();

  return useCallback(
    (e: React.UIEvent<HTMLElement>): void => {
      if (!(e.currentTarget instanceof HTMLElement) || !(e.target instanceof Node)) {
        return;
      }

      if (!e.currentTarget.contains(e.target)) {
        return;
      }

      if (e.target instanceof HTMLDivElement) {
        const { target } = e;

        if (
          target.offsetHeight + target.scrollTop + 1 >= target.scrollHeight &&
          count &&
          dataArrayLength < count &&
          page * Pagination.TAKE < count
        ) {
          dispatch(actionCreator({ page: page + 1 }));
        }
      }
    },
    [count, dataArrayLength, page, dispatch],
  );
};
